import { render, staticRenderFns } from "./Cartoon.vue?vue&type=template&id=6e6bc6aa&scoped=true&"
import script from "./Cartoon.vue?vue&type=script&lang=js&"
export * from "./Cartoon.vue?vue&type=script&lang=js&"
import style0 from "./Cartoon.vue?vue&type=style&index=0&id=6e6bc6aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6bc6aa",
  null
  
)

export default component.exports